<template>
    <v-form ref="form">
        <v-row>
            <v-col cols="12">
                <v-autocomplete
                    label="Payment Mode"
                    v-model="form.payment_mode"
                    :items="paymentModes"
                    item-text="text"
                    item-value="value"
                    :rules=[isRequired]
                    outlined
                    dense
                    hide-details="auto">
                </v-autocomplete>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-autocomplete
                    label="Ledger Account"
                    v-model="form.ledger_account_id"
                    outlined
                    :items="ledgerAccounts"
                    item-text="display_name"
                    item-value="id"
                    :rules="[isRequired]"
                    @update:search-input="ledgerAccountSearch"
                    dense
                    hide-details="auto">
                </v-autocomplete>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { isRequired } from './../../utils/validations';


export default {
    name: "PurchasePaymentAccountForm",
    props: {
        value: Object
    },
    data() {
        return {
            form: {
                payment_mode: null,
                ledger_account_id: null
            }
        }
    },
    computed: {
        ...mapGetters({
            ledgerAccounts: "purchase/ledgerAccount/list",
            paymentModes: "purchase/paymentMode/list"
        })
    },
    watch: {
        form: {
            deep: true,
            handler(form) {
                this.$emit("input", {...form});
            }
        }
    },
    methods: {
        isRequired,
        ...mapActions({
            ledgerAccountSearch: "purchase/ledgerAccount/search",
            fetchPaymentModes: "purchase/paymentMode/index"
        }),
        validate() {
            return this.$refs.form.validate();
        }
    },
    mounted() {
        this.fetchPaymentModes();
        if(this.value) {
            this.form = {...this.value};
        }
    }
}
</script>

<style>

</style>